import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RedirectCommand,
  ResolveFn,
  UrlTree
} from '@angular/router';
import { StreamService } from '../services/stream_service';
import { Stream } from '../types/stream';

type StreamDetailsResolveResult = Stream | null | RedirectCommand;
type StreamListResolveResult = Stream[] | RedirectCommand;

const getStreamInfo = (
  streamId: string,
  streamService: StreamService,
  router: Router
): Promise<Stream | null | RedirectCommand> => {

  const notFoundUrl: UrlTree = router.parseUrl('/404');

  return streamService.getStreamInfo(streamId, true, true).then((stream) => {
    if (stream && stream.id) {
      return stream;
    } else {
      return null;
    }
  }, () => {
    return new RedirectCommand(notFoundUrl);
  })
  .catch(() => {
    return new RedirectCommand(notFoundUrl);
  });
};

export const streamDetailsResolver: ResolveFn<StreamDetailsResolveResult> = (
  route: ActivatedRouteSnapshot
) => {
  const streamService = inject(StreamService);
  const router = inject(Router);

  const notFoundUrl: UrlTree = router.parseUrl('/404');

  if (route.params['custom-url']) {
    const customUrl = route.params['custom-url'];
    return streamService.getStreamIdFromCustomUrl(customUrl)
      .then(result => getStreamInfo(result.channel.id, streamService, router))
      .catch(() => {
        return new RedirectCommand(notFoundUrl);
      });
  } else {
    return getStreamInfo(route.params['id'], streamService, router);
  }
};

export const streamListResolver: ResolveFn<StreamListResolveResult> = () => {
  const streamService = inject(StreamService);

  return streamService.getUserStreams().then((streams) => {
    if (streams) {
      return streams;
    } else {
      return [];
    }
  }, () => []);
};